import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
} from '@mui/material';
import { addUserToGroup } from '../apis/apis';
import { EMAIL_REGEX } from '../apis/helpers';

export default function AddUserDialog({ open, onClose, groupId, onUserAdded }) {
  const [newUserEmail, setNewUserEmail] = useState('');
  const [error, setError] = useState('');

  const validateEmail = (email) => {
    if (!email) {
      setError('Email is required');
      return false;
    }
    if (!EMAIL_REGEX.test(email)) {
      setError('Please enter a valid email address');
      return false;
    }
    setError('');
    return true;
  };

  const handleAddUser = async () => {
    if (!validateEmail(newUserEmail)) return;

    try {
      await addUserToGroup(groupId, newUserEmail);
      setError('');
      onUserAdded();
      handleClose();
    } catch (error) {
      setError(error.message);
      console.error('Error adding user:', error);
    }
  };

  const handleClose = () => {
    setNewUserEmail('');
    setError('');
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: {
            width: '20vw',
            minWidth: '300px',
            maxWidth: '400px',
            height: 'fit-content'
          }
        }
      }}
    >
      <DialogTitle>Add Member</DialogTitle>
      <DialogContent sx={{ pb: 3 }}>
        <TextField
          autoFocus
          margin="dense"
          label="Email Address"
          type="email"
          fullWidth
          value={newUserEmail}
          onChange={(e) => {
            setNewUserEmail(e.target.value);
            if (error) validateEmail(e.target.value);
          }}
          error={!!error}
          helperText={error}
          sx={{
            '& .MuiFormHelperText-root': {
              position: 'absolute',
              bottom: '-20px',
            }
          }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose}>Cancel</Button>
        <Button 
          onClick={handleAddUser} 
          variant="contained"
          disabled={!!error}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
} 